import { chromeYellow, spaceCadet, sanguine } from '@cogneed/react-utils';
import { Box, alpha, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 2,
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  padding: '4px 12px',
  backgroundColor: spaceCadet[700],
  border: `solid ${chromeYellow[500]}`,
  borderWidth: '0 0 2px 0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: 'white',
  height: 48,

  '&#login-header': {
    '& > .MuiBox-root': {
      width: '100%',
      maxWidth: 768,
      marginLeft: 'auto',
      marginRight: 'auto',

      '& img': {
        height: 18,
      },
    },
  },

  '& .MuiButton-root': {
    minWidth: 0,
    padding: 6,
    marginTop: -2,
    marginBottom: -2,
    fontSize: 24,
    color: spaceCadet[400],
    '&:hover': {
      backgroundColor: alpha(spaceCadet[400], 0.25),
      color: spaceCadet[100],
    },
    '&.active': {
      backgroundColor: alpha(spaceCadet[400], 0.25),
      color: spaceCadet[100],
    },
    '&.reload': {
      fontSize: 13,
      padding: '4px 12px',
      color: spaceCadet[100],
      borderRadius: 6,
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      textTransform: 'none',
      marginLeft: -90,
    },
  },
  '& .MuiBox-root': {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
  },
  '& .MuiBadge-badge': {
    top: '2px',
    right: 2,
    backgroundColor: sanguine[500],
  },

}));

export default StyledBox;
